import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Car } from "lucide-react";
import { Link } from "react-router-dom";

export default function CarRentalSearchPage() {
  return (
    <div className="container mx-auto flex items-center justify-center py-16">
      <Card className="max-w-2xl text-center">
        <CardHeader>
          <div className="mx-auto bg-primary/10 text-primary p-3 rounded-full w-fit mb-4">
            <Car className="h-8 w-8" />
          </div>
          <CardTitle>Car Rental Search is Coming Soon!</CardTitle>
          <CardDescription>
            We're building partnerships to help you find the best car rentals for your Scottish adventure, right from this page.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-6">
            Soon, you'll be able to arrange your transport and complete your trip planning in one place.
          </p>
          <Button asChild>
            <Link to="/itinerary">Back to Your Itineraries</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
